var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.scenario
        ? _c("VideoControl", { on: { subcommand: _vm.subcommand } })
        : _c("div", { staticClass: "notice" }, [
            _vm._v("Er is geen scenario geselecteerd.")
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }